export type VesselDetailMode = 'Q88' | 'VESSEL_PARTICULARS'

const TANKER_VESSEL_TYPES = new Set([
  'OIL_TANKER',
  'TANKER',
  'GAS_CARRIER',
  'CHEMICAL_TANKER',
  'PRODUCT_TANKER',
  'LNG_CARRIER',
  'LPG_CARRIER',
  'CRUDE_OIL_TANKER',
  'BUNKER_TANKER',
])

export const LEGACY_VESSEL_TYPE_ALIASES: Record<string, string> = {
  SPUD_PANTOON: 'SPUD_PONTOON',
}

export function normalizeVesselTypeCode(vesselType?: string | null): string {
  if (!vesselType) return ''
  const normalized = vesselType.trim().toUpperCase()
  return LEGACY_VESSEL_TYPE_ALIASES[normalized] ?? normalized
}

/** Tanker if vessel type matches the known tanker enums used in the system. */
export function isQ88Applicable(vesselType?: string | null): boolean {
  const normalized = normalizeVesselTypeCode(vesselType)
  if (!normalized) return false
  return TANKER_VESSEL_TYPES.has(normalized)
}

export function getVesselDetailMode(vesselType?: string | null): VesselDetailMode {
  return isQ88Applicable(vesselType) ? 'Q88' : 'VESSEL_PARTICULARS'
}

export function getVesselDetailLabel(
  vesselType: string | null | undefined,
  action: 'fill' | 'view' | 'print'
): string {
  const tanker = isQ88Applicable(vesselType)
  if (action === 'fill') {
    return tanker ? 'Edit Q88' : 'Edit Vessel Particulars'
  }
  if (action === 'view') {
    return tanker ? 'View Q88' : 'View Vessel Particulars'
  }
  return tanker ? 'Print Q88' : 'Print Vessel Particulars'
}

export function getVesselDetailHelperText(vesselType?: string | null): string {
  return isQ88Applicable(vesselType)
    ? 'Q88 details will be applicable for this vessel.'
    : 'Vessel Particulars will be applicable for this vessel.'
}
